$(document).ready(function () {

  // $('#storeModal').modal('show');

  // $(document).on('click', '#storeModal .btn-circle', function (e) {
  //   $('#storeModal').modal('hide');
  // });

  var $promoModal = $('#promoModal');

  if ($promoModal.length) {
    var promoModalShown = false;
    $(window).on('scroll', function () {
      if (!promoModalShown && $(window).scrollTop() > 0) {
        promoModalShown = true;
        $promoModal.modal('show');
      }
    });
  }

  // swiperjs.min.js is only loaded on the homepage (master.blade.php),
  // since that's the only page with a .swiper-main carousel — guard so
  // this doesn't throw "Swiper is not defined" everywhere else.
  if (typeof Swiper !== 'undefined' && document.querySelector('.swiper-main .swiper-container')) {
    new Swiper('.swiper-main .swiper-container', {
      loop: !0,
      autoHeight: !0,
      autoplay: { delay: 4e3 },
      preloadImages: false,
      lazy: { loadPrevNext: true },
    });
  }

  // .line-cta__video ships with no poster/source src (only data-poster/data-src)
  // so it costs nothing on page load; only fetch the ~90KB of media once the
  // banner is about to scroll into view, same intent as the swiper-lazy promo slides.
  var lineCtaVideo = document.querySelector('.line-cta__video');
  if (lineCtaVideo) {
    if ('IntersectionObserver' in window) {
      var lineCtaObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var video = entry.target;
            video.poster = video.dataset.poster;
            video.querySelectorAll('source[data-src]').forEach(function (source) {
              source.src = source.dataset.src;
            });
            video.load();
            video.play().catch(function () {});
            observer.unobserve(video);
          });
        },
        { rootMargin: '200px 0px' }
      );
      lineCtaObserver.observe(lineCtaVideo);
    } else {
      // No IntersectionObserver support: fall back to loading it plainly
      // rather than leaving the banner permanently blank.
      lineCtaVideo.poster = lineCtaVideo.dataset.poster;
      lineCtaVideo.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
      });
      lineCtaVideo.load();
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source');

  if (source != null) {
    $('#source').val(source);
    setCookie('source', source, 30);
  }

  var source_ls = getCookie('source');

  if (source_ls != '') {
    $('#source').val(source_ls);
  }

  $(document).on('click', '#btn-side-menu-right', function (e) {
    e.preventDefault();
    $('#side-menu-right').width(300);
  });

  $(document).on('click', '#side-menu-right .close', function (e) {
    e.preventDefault();
    $('#side-menu-right').width(0);
  });

  function setCookie(name, value, daysToLive) {
    // Encode value in order to escape semicolons, commas, and whitespace
    var cookie = name + '=' + encodeURIComponent(value);

    if (typeof daysToLive === 'number') {
      /* Sets the max-age attribute so that the cookie expires
        after the specified number of days */
      cookie += '; max-age=' + daysToLive * 24 * 60 * 60;
      // Pin to the site root — without this the cookie binds to the current
      // URL's directory and the once-per-day gate breaks on deep pages.
      cookie += '; path=/';

      document.cookie = cookie;
    }
  }

  function getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(';');

    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split('=');

      /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
      if (name == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
      }
    }

    // Return null if not found
    return null;
  }
});
